import React, { FC, useRef, useState } from 'react';
import DescLabel from 'src/components/atoms/label/DescLabel';
import TableGrid from 'src/components/atoms/grid/TableGrid';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import CompanyDetail from 'src/components/molecules/table/CompanyDetail';
import { getDateMonth, getDateFormat } from 'src/utils/dateSet';
import { myInfoDataStore } from 'src/store/myInfo';
import { salaryDataStore } from 'src/store/mySalaryInfo';
import { preworkDataStore } from 'src/store/preworkInfo';
import { setDeDataStore } from 'src/fetch/data/store';

import { contentModalViewStore } from 'src/store/modal';
import { gridOption } from './gridOption';
import './style.scss';

interface Props {
  data?: any;
}

const BeforeWork: FC<Props> = ({ data }) => {
  const dataSet = {};
  const preworkInfoDataStateResult = preworkDataStore((state: any) => state.result).data || [];
  const orgData = preworkInfoDataStateResult || [];

  const totalCount = 1;
  const bindStateData = setDeDataStore(state => state.bindData);
  const optionSet: any = gridOption(preworkInfoDataStateResult, orgData, totalCount, bindStateData);
  const setContentModalState = contentModalViewStore((state: any) => state.set);

  const stateOption: any = {
    label: optionSet.label || [],
    data: optionSet.data || [],
    styleDef: optionSet.styleDef,
    rowStyleDef: {},
    totalCount,
  };

  const rowClickEvt = () => {};
  const pagingClick = () => {};
  const sortClickEvt = () => {};
  const addEvt = () => {
    const payload = {
      active: '_active',
      title: '근무지 추가',
      content: <CompanyDetail type="add" data={{}} />,
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };

  return (
    <div className="_step_b_before_work">
      <div className="_content">
        <TableGrid
          gridOption={stateOption}
          rowClickEvt={rowClickEvt}
          pagingClick={pagingClick}
          sortClickEvt={sortClickEvt}
          noContentStyleDef={{ height: '100px' }}
          dataType="object"
          viewType="type4"
        />
      </div>
      <div className="_btn_div">
        <DefaultButton
          text="종(전)근무지 추가"
          clickEvent={e => addEvt()}
          icon=""
          status=""
          type="type2"
          styleDef={{
            width: '250px',
          }}
        />
      </div>
    </div>
  );
};

export default BeforeWork;
